module.exports = __webpack_public_path__ + "img/2.e195d6b5.png";